import template from './_faq.pug'

// @vue/component
export default Vue.extend({
  name: "faq-partial",
  template: template(),

  props: {
    faq: {
      type: Object,
      default() {
        return {
          id: undefined,
          question: undefined,
          answer: undefined,
          instagram: undefined
        }
      }
    }
  },

  data() {
    return {
      open: false
    }
  },

  methods: {
    toggleOpen() {
      this.open = !this.open

      if (this.open) this.scrollToQuestion()
    },

    scrollToQuestion() {
      setTimeout(() => {
        this.$refs.answer.scrollIntoView({block: 'start', behavior: 'smooth'})
      }, 150)
    }
  }
})
